import * as React from 'react';
import AddWidget from './css/dark/img/add-widget.svg';
import NewDashboard from './css/dark/img/new-dashboard.svg';
import DuplicateDashboard from './css/dark/img/duplicate-dashboard.svg';
import PublicUrls from './css/dark/img/public-urls.svg';
import ChangeBg from './css/dark/img/change-bg.svg';
import EditDashboard from './css/dark/img/edit-dashboard.svg';
import TvMode from './css/dark/img/tv-mode.svg';
import ExportDashboard from './css/dark/img/export-dashboard.svg';
import DeleteWidget from './css/dark/img/delete-widget.svg';

function DashboardHeaderIcons() {

    return (
        <div>

            <ul>
                <li><img src={AddWidget} alt="" /></li>
                <li><img src={NewDashboard} alt="" /></li>
                <li><img src={DuplicateDashboard} alt="" /></li>
                <li><img src={PublicUrls} alt="" /></li>
                <li><img src={ChangeBg} alt="" /></li>
                <li><img src={EditDashboard} alt="" /></li>
                <li><img src={TvMode} alt="" /></li>
                <li><img src={ExportDashboard} alt="" /></li>
                <li><img src={DeleteWidget} alt="" /></li>
            </ul>

        </div>
    )
}

export default DashboardHeaderIcons;